export class KeyValueColorObject {
	public key: string;

	public value: string;

	public color: string;

	constructor(_key?: string, _value?: string, _color?: string) {
		this.key = _key;
		this.value = _value;
		this.color = _color;
	}
}